import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { TransactionType } from '@dealstack/shared/lib/generated';
import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';

export enum BULK_EDIT_TRANSACTIONS_FORM_FIELD {
	TYPE = 'type',
	BUYER = 'destinationId',
	SELLER = 'sourceId',
	BUYER_MIP = 'toMipId',
	SELLER_MIP = 'fromMipId',
	DATE = 'date',
}

export interface BulkUpdateTransactionsFormValues {
	[BULK_EDIT_TRANSACTIONS_FORM_FIELD.TYPE]?: TransactionType;
	[BULK_EDIT_TRANSACTIONS_FORM_FIELD.BUYER]?: string;
	[BULK_EDIT_TRANSACTIONS_FORM_FIELD.SELLER]?: string;
	[BULK_EDIT_TRANSACTIONS_FORM_FIELD.BUYER_MIP]?: string;
	[BULK_EDIT_TRANSACTIONS_FORM_FIELD.SELLER_MIP]?: string;
	[BULK_EDIT_TRANSACTIONS_FORM_FIELD.DATE]?: Date;
}

export const useBulkUpdateTransactionsDrawerController = () => {
	const capManageController = useContext(CapManageControllerContext);
	const editTransactionForm = useForm<BulkUpdateTransactionsFormValues>({
		mode: 'all',
	});

	return {
		editTransactionForm,
		mipSelectOptions: capManageController.mipSelectOptions,
	};
};
